import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
const _excluded = ["id", "variant", "isSelected", "isDisabled", "controls", "children", "styles"];
var _dec, _class, _Tab;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import { Component } from 'react';
import { passthroughProps, callRenderProp } from '@instructure/ui-react-utils';
import { View } from '@instructure/ui-view';
import { withStyle } from '@instructure/emotion';
import generateStyle from "./styles.js";
import generateComponentTheme from "./theme.js";
import { allowedProps } from "./props.js";
/**
---
parent: Tabs
id: Tabs.Tab
---
**/
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
let Tab = (_dec = withStyle(generateStyle, generateComponentTheme), _dec(_class = (_Tab = class Tab extends Component {
  constructor(...args) {
    super(...args);
    this.handleClick = event => {
      const _this$props = this.props,
        onClick = _this$props.onClick,
        index = _this$props.index,
        id = _this$props.id,
        isDisabled = _this$props.isDisabled;
      if (isDisabled) {
        return;
      }
      if (typeof onClick === 'function') {
        onClick(event, {
          index,
          id
        });
      }
    };
    this.handleKeyDown = event => {
      const _this$props2 = this.props,
        onKeyDown = _this$props2.onKeyDown,
        index = _this$props2.index,
        id = _this$props2.id,
        isDisabled = _this$props2.isDisabled;
      if (isDisabled) {
        return;
      }
      if (typeof onKeyDown === 'function') {
        onKeyDown(event, {
          index,
          id
        });
      }
    };
  }
  componentDidMount() {
    var _this$props$makeStyle, _this$props3;
    (_this$props$makeStyle = (_this$props3 = this.props).makeStyles) === null || _this$props$makeStyle === void 0 ? void 0 : _this$props$makeStyle.call(_this$props3);
  }
  componentDidUpdate() {
    var _this$props$makeStyle2, _this$props4;
    (_this$props$makeStyle2 = (_this$props4 = this.props).makeStyles) === null || _this$props$makeStyle2 === void 0 ? void 0 : _this$props$makeStyle2.call(_this$props4);
  }
  render() {
    const _this$props5 = this.props,
      id = _this$props5.id,
      variant = _this$props5.variant,
      isSelected = _this$props5.isSelected,
      isDisabled = _this$props5.isDisabled,
      controls = _this$props5.controls,
      children = _this$props5.children,
      styles = _this$props5.styles,
      props = _objectWithoutProperties(_this$props5, _excluded);
    return _jsx(View, {
      ...passthroughProps(props),
      as: "div",
      role: "tab",
      id: id,
      onClick: this.handleClick,
      onKeyDown: this.handleKeyDown,
      css: styles === null || styles === void 0 ? void 0 : styles.tab,
      "aria-selected": isSelected ? 'true' : void 0,
      "aria-disabled": isDisabled ? 'true' : void 0,
      "aria-controls": controls,
      tabIndex: isSelected && !isDisabled ? 0 : void 0,
      position: "relative",
      focusPosition: "inset",
      children: callRenderProp(children)
    });
  }
}, _Tab.displayName = "Tab", _Tab.componentId = 'Tabs.Tab', _Tab.allowedProps = allowedProps, _Tab.defaultProps = {
  variant: 'default',
  isDisabled: false,
  isSelected: false
}, _Tab)) || _class);
export default Tab;
export { Tab };